import { render, staticRenderFns } from "./VeJwCjQingkaoModal.vue?vue&type=template&id=4beddb68"
import script from "./VeJwCjQingkaoModal.vue?vue&type=script&lang=js"
export * from "./VeJwCjQingkaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports